<template>
    <div>

        <div class="img-content">
            <img src="../assets/images/main.jpg" alt="">
        </div>

        <div class="font">
            <!-- 顶部文字 -->
            <!-- <h1>广州艾乐肤</h1> -->

            <!-- 地址 -->
            <!-- <p>地址：广州市天河区珠江西路15号珠江城大厦44楼4408</p> -->

            <!-- 邮箱 -->
            <p>邮箱：wangfei@akfcosmetic.cn</p>
            <!-- <p></p> -->
            <p>韩国品牌方官方邮箱：akf2018@akfcosmetic.co.kr</p>
            <!-- 联系人 -->
            <p>ΛKF品牌中国营销中心：艾乐肤（广州）生物科技有限公司</p>


        </div>

        <!-- 图片及文字说明 -->
    <div class="QRimg">
        <div>
            <img src="../assets/images/QRcode/gzh.jpg" alt="QR Code 1">
            <p>扫码关注公众号</p>
        </div>
        <div>
            <img src="../assets/images/QRcode/sph.jpg" alt="QR Code 1">
            <p>扫码关注视频号</p>
        </div>
        <div>
            <img src="../assets/images/QRcode/dy.jpg" alt="QR Code 1">
            <p>扫码关注抖音号</p>
        </div>
        <div>
            <img src="../assets/images/QRcode/ks.jpg" alt="QR Code 1">
            <p>扫码关注快手号</p>
        </div>
        <div>
            <img src="../assets/images/QRcode/xhs97.jpg" alt="QR Code 1">
            <p>扫码关注小红书</p>
        </div>
    </div>


    </div>
</template>

<script>
export default {
    name: 'ContactUsPage'
};
</script>

<style scoped>
@media only screen and (max-width: 996px) {
    .font {
        margin-top: 100px;
        width: 100%;
        text-align: center;
        line-height: 80px;
    }

    .font p {
        font-size: 1rem;
    }

    .font span {
        font-size: 1.3rem;
        font-weight: bold;
    }
}

/* 桌面端 */
@media only screen and (min-width: 996px) {
    .font {
        font-size: 20px;
        margin-top: 100px;
        width: 100%;
        text-align: center;
        line-height: 80px;
    }
}
/* 样式 */
.img-content {
  text-align: center;
}

/* .img-content img {
  width: 50%; 
/* } */

.QRimg {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.QRimg div {
  text-align: center;
  margin: 10px; /* 调整图片之间的间距 */
}
.QRimg img {
  width: 188px;
  height: 188px;
}

</style>